// Generates and persists a device_id in localStorage for consent binding.

const KEY = 'device_id';

function uuid4(): string {
  // RFC4122-ish uuid v4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0xf) >> 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const id = uuid4();
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    // Fallback to session-only id when storage is unavailable
    return uuid4();
  }
}
